{
  "new-app-version-notification": {
    "buttons": {
      "update": "Mise à jour"
    },
    "text": {
      "new-version-available": "La nouvelle version est disponible"
    }
  }
}
